import styled from 'styled-components'

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'

import { color } from 'styles/colors'

import { NavLink } from 'react-router-dom'

import React from 'react'

type BreadCrumbLinkProps = {
  toRoute: string
  direction: 'forward' | 'back'
  label: string
  onClick?: () => void
}

const BreadCrumbLink = ({ toRoute, direction, label, onClick }: BreadCrumbLinkProps) => {
  if (direction === 'forward') {
    return (
      <S.BreadCrumbLink to={toRoute} onClick={onClick} data-testid={label}>
        <span>{label}</span>
        <S.ArrowForwardIosIcon fontSize="small" />
      </S.BreadCrumbLink>
    )
  } else {
    return (
      <S.BreadCrumbLink to={toRoute} onClick={onClick} data-testid={label}>
        <S.ArrowBackIosIcon fontSize="small" />
        <span>{label}</span>
      </S.BreadCrumbLink>
    )
  }
}

const S = {
  BreadCrumbLink: styled(NavLink)`
    color: ${color('breadCrumbsText')};
    padding: 5px 10px;
    border-radius: 6px;

    &:hover {
      color: ${color('breadCrumbsTextHover')};
      background-color: ${color('breadCrumbsBackgroundHover')};
    }
  `,
  ArrowForwardIosIcon: styled(ArrowForwardIosIcon)`
    font-size: .75rem;
    margin-left: 10px;
  `,
  ArrowBackIosIcon: styled(ArrowBackIosIcon)`
    font-size: .75rem;
    margin-right: 10px;
  `

}

export default BreadCrumbLink
